import { ADD_FILE, ARCHIVE_FILES, DELETE_FILES, EDIT_FILE, GET_FILES, SHARE_FILE, UN_SHARE_FILE } from './file.type';

export const getFiles = (params, load) => {
    return {
        type: GET_FILES,
        payload: { params, load },
    };
};

export const addFiles = (params, body) => {
    return {
        type: ADD_FILE,
        payload: { params, body },
    };
};

export const editFile = (params, id, body) => {
    return {
        type: EDIT_FILE,
        payload: { params, id, body },
    };
};

export const deleteFiles = (params, docIds) => {
    return {
        type: DELETE_FILES,
        payload: { params, docIds },
    };
};

export const archiveFiles = (params, docIds) => {
    return {
        type: ARCHIVE_FILES,
        payload: { params, docIds },
    };
};

export const shareFile = (params, resourceId, fileId, body) => {
    return {
        type: SHARE_FILE,
        payload: { params, resourceId, fileId, body },
    };
};
export const unShareFile = (params, resourceId, fileId) => {
    return {
        type: UN_SHARE_FILE,
        payload: { params, resourceId, fileId },
    };
};
